import { render, staticRenderFns } from "./Load.vue?vue&type=template&id=5bdbd2e6&scoped=true&"
import script from "./Load.vue?vue&type=script&lang=js&"
export * from "./Load.vue?vue&type=script&lang=js&"
import style0 from "./Load.vue?vue&type=style&index=0&id=5bdbd2e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdbd2e6",
  null
  
)

export default component.exports